export default "__VITE_ASSET__8243aac6__"